.root {
  & {
    background-color: var(--theme--color--grey--ultra-light);
  }

  .image {
    pointer-events: none;
    width: 100%;
    aspect-ratio: var(--theme--tokens--card--media--aspect-ratio);
    object-fit: cover;
  }

  .content {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    padding: var(--theme--tokens--card--padding);

    &:empty {
      display: none;
    }
  }
}